import { Reducer } from 'redux';

import { ViewerActivityForSummaryLoadAction } from '../../domains/viewerActivity/actions.types';

import { ViewerActivityForSummaryLifecycle } from './types';

const initialState: ViewerActivityForSummaryLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<ViewerActivityForSummaryLifecycle, ViewerActivityForSummaryLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'VIEWER_ACTIVITY_FOR_SUMMARY.LOAD_PENDING':
      return { ...initialState, pending: true };
    case 'VIEWER_ACTIVITY_FOR_SUMMARY.LOAD_FULFILLED':
      return { ...initialState, fulfilled: action.payload.entities.viewerActivity };
    case 'VIEWER_ACTIVITY_FOR_SUMMARY.LOAD_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
